import { createAsyncThunk } from '@reduxjs/toolkit';
import { callGetValidationDni } from '../../services/ValidationDniService';
import { contactBackBff } from '../../../src/config/paths';

export const getValidateDni = createAsyncThunk(
  'validate/dni',
  async (params) => {
    const { rut, serie, reCaptchaToken } = params;
    const response = await callGetValidationDni(
      rut,
      serie,
      reCaptchaToken,
      contactBackBff,
    );
    return response.data;
  },
);
